var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01997 4.95931C1.9519 3.89124 2.5052 2.06381 3.98635 1.76758L4.53416 1.65802C7.4822 1.06841 10.5178 1.06841 13.4658 1.65802L14.0136 1.76758C15.4948 2.06381 16.0481 3.89124 14.98 4.95931C14.4305 5.50886 14.3452 6.36991 14.7763 7.01656L15.3284 7.84466C15.9527 8.78116 16.3504 9.85015 16.49 10.967L17.1619 16.3419C17.2098 16.7252 17.1713 17.1145 17.0491 17.4809C16.697 18.5374 15.7083 19.25 14.5947 19.25H3.40531C2.29171 19.25 1.30304 18.5374 0.950886 17.4809C0.82872 17.1145 0.790181 16.7252 0.838098 16.3419L1.50996 10.967C1.64957 9.85015 2.04728 8.78116 2.67161 7.84466L3.22368 7.01656C3.65478 6.36991 3.56952 5.50886 3.01997 4.95931Z",
    stroke: "#DDDFDD",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRice);
export default __webpack_public_path__ + "static/media/rice.a87a9ea7.svg";
export { ForwardRef as ReactComponent };